<template>
  <section class="dashboard-section m-t-lg m-b-lg">
    <h2><i class="far fa-question-circle"></i> Job Requests</h2>
    <div class="ibox">
      <div class="ibox-content">
        <ul class="list-detail list-detail-job-request">
          <job-request-item
            v-for="job in jobs"
            :key="job.id"
            :job="job">
          </job-request-item>

          <li class="text-center text-muted" v-if="haveNoJobRequests">
            <strong>No job requests found.</strong>
          </li>
        </ul>
      </div>
      <div class="ibox-footer">
        <router-link :to="{ name: 'jobs.requests' }">View All</router-link>
      </div>
    </div>

    <job-request-modal></job-request-modal>
  </section>
</template>

<script>
  import { mapActions } from 'vuex'
  import { map, findIndex } from 'lodash'
  import { JobDecorator } from 'decorators'
  import JobRequestItem from 'components/jobs/JobRequestItem'
  import JobRequestModal from 'components/jobs/JobRequestModal'

  export default {
    components: {
      JobRequestItem,
      JobRequestModal
    },

    data () {
      return {
        jobs: []
      }
    },

    computed: {
      haveNoJobRequests () {
        return this.jobs.length === 0
      }
    },

    created () {
      this.getJobs({ commodity: 'all', requests: true, page_size: 3 })
        .then((response) => {
          this.jobs = map(response.data.data, job => new JobDecorator(job))
        })

      this.$bus.$on('jobRequestAcceptedOrDeclined', this.removeJobRequestFromList)
    },

    beforeDestroy () {
      this.$bus.$off('jobRequestAcceptedOrDeclined', this.removeJobRequestFromList)
    },

    methods: {
      ...mapActions('job', ['getJobs']),

      removeJobRequestFromList (job) {
        this.jobs.splice(findIndex(this.jobs, existing => existing.id === job.id), 1)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// JobRequestList.vue?06523b31